import { FC, ReactNode, useEffect } from 'react';
import { LoadingModal } from '../LoadingModal.client';

interface Props {
  loading: boolean;
  error: Error | null;
  children: ReactNode;
  onClose?: () => void;
}

export const FormWrapper: FC<Props> = ({ loading, error, children, onClose }) => {
  useEffect(() => {
    if (error) window.alert('500: サーバーでエラーが発生しました。');
  }, [error]);

  return (
    <>
      {children}
      {loading && <LoadingModal loading={loading} onClose={onClose} />}
    </>
  );
};
